import { render } from "./CommentCard.vue?vue&type=template&id=43b6174e&scoped=true&ts=true"
import script from "./CommentCard.vue?vue&type=script&lang=ts"
export * from "./CommentCard.vue?vue&type=script&lang=ts"

import "./CommentCard.vue?vue&type=style&index=0&id=43b6174e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b6174e"]])

export default __exports__